import { AxiosRequestConfig } from 'axios'

export interface ScansByUserLevelParams {
  endDate: string
  storeIds?: string
}

export interface ScansByUserLevelResponse {
  data: {
    dates: Array<{
      date: string
      total: number
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [key: string]: string | number // Dynamic level properties like level_1, level_2, etc.
    }>
    levels: Array<{
      name: string
      level: number
    }>
  }
}

export const getScansByUserLevel = (params: ScansByUserLevelParams): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: '/dashboard/scans-by-user-level',
    params,
  }
}
